export const SHORT_COMPANY_ID_LENGTH = 8;

const CANONICAL_ORIGIN = 'https://vitreous.support';

/** First 8 letters/numbers from a company UUID (hyphens stripped). */
export function formatShortCompanyId(companyId: string | null | undefined): string {
  if (!companyId) return '';
  return String(companyId)
    .replace(/[^a-zA-Z0-9]/g, '')
    .slice(0, SHORT_COMPANY_ID_LENGTH)
    .toLowerCase();
}

/** True for global `/tvdashboard` and company `/tvdashboard-{shortId}` routes. */
export function isTvDashboardPath(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  return path === '/tvdashboard' || /^\/tvdashboard-[a-z0-9]+$/i.test(path);
}

/** Extract short company id from `/tvdashboard-{shortId}` (empty for global `/tvdashboard`). */
export function parseCompanyTvDashboardShortId(pathname: string): string | undefined {
  const path = pathname.replace(/\/+$/, '') || '/';
  const match = path.match(/^\/tvdashboard-([a-z0-9]+)$/i);
  return match?.[1]?.toLowerCase();
}

/** Public company TV dashboard URL for display in admin profiles. */
export function getCompanyTvDashboardUrl(companyId: string): string {
  const hostname = typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : '';
  const isProduction =
    hostname === 'vitreous.support' ||
    hostname.includes('vitreous.support') ||
    hostname === 'www.vitreous.support';
  const origin = isProduction ? CANONICAL_ORIGIN : (typeof window !== 'undefined' ? window.location.origin : CANONICAL_ORIGIN);
  return `${origin}/tvdashboard-${formatShortCompanyId(companyId)}`;
}
